export default "__VITE_ASSET__8578b4fa__"